import { Phone } from "lucide-react";

export default function PrimaryButton() {
  return (
    <>
      <a href="tel:(312) 555-0147" className="flex w-fit items-center gap-2 font-bold bg-blue-600 hover:bg-blue-700 transition-all px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25 text-sm">
                  <Phone className="w-4 h-4" /> (312) 555-0147
      </a>
    </>
  );
}
